import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';

import messagesEn from '@/intl/en';
import messagesPtBr from '@/intl/pt-BR';

import { intlOperations, intlSelectors } from '@/state/ducks/intl';

const IntlWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const appLocale = useSelector(intlSelectors.selectSystemLocale);

  useEffect(() => {
    if (!appLocale) dispatch(intlOperations.changeSystemLocale('pt-BR'));
  }, []);

  const messages = {
    en: messagesEn,
    'pt-BR': messagesPtBr,
  };

  return (
    <IntlProvider
      locale={appLocale || 'pt-BR'}
      messages={messages[appLocale || 'pt-BR']}
      defaultLocale="pt-BR"
    >
      {children}
    </IntlProvider>
  );
};

IntlWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.array,
  ]),
};

export default IntlWrapper;
